/**
 * TanStack Query hooks for `meta-facebook-ads-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	metaFacebookAdsIntegrationQueryKeys,
	type CreateMetaFacebookAdsIntegrationBody,
	type ListMetaFacebookAdsIntegrationResponse,
	type MetaFacebookAdsIntegrationRow,
} from "./api";

export function useMetaFacebookAdsIntegrationList(): UseQueryResult<ListMetaFacebookAdsIntegrationResponse, Error> {
	return useQuery({
		queryKey: metaFacebookAdsIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useMetaFacebookAdsIntegrationCreate(): UseMutationResult<MetaFacebookAdsIntegrationRow, Error, CreateMetaFacebookAdsIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: metaFacebookAdsIntegrationQueryKeys.all });
		},
	});
}

export function useMetaFacebookAdsIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: metaFacebookAdsIntegrationQueryKeys.all });
		},
	});
}
